import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ChannelNotification } from '@app/shared/services/channel-notifications/channel-notifications.service';

interface NotificationGroup {
  title: string;
  notifications: ChannelNotification[];
  isExpanded?: boolean;
  isActionRequired?: boolean;
}

const ACTION_REQUIRED_TYPES = ['ADD_HOST_PAYOUT_INFO', 'ADD_TAX_PAYER_INFO', 'KYC_REQUIRED_ACTION_CARD'];

@Component({
  selector: 'sbnb-dialog-channel-notifications',
  templateUrl: './dialog-channel-notifications.component.html',
  styleUrls: ['./dialog-channel-notifications.component.scss'],
})
export class DialogChannelNotificationsComponent {
  actionRequiredGroups: NotificationGroup[] = [];
  listingIssueGroups: NotificationGroup[] = [];
  isLoading = true;

  constructor(
    public dialogRef: MatDialogRef<DialogChannelNotificationsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { notifications: ChannelNotification[] }
  ) {}

  groupNotifications() {
    this.isLoading = true;
    this.actionRequiredGroups = [];
    this.listingIssueGroups = [];

    if (this.data?.notifications?.length > 0) {
      // First group action required notifications
      const actionRequired = this.data.notifications.filter((n) => ACTION_REQUIRED_TYPES.includes(n.notification_type));
      actionRequired.forEach((notification) => {
        const group = this.actionRequiredGroups.find((g) => g.title === notification.title);
        if (group) {
          group.notifications.push(notification);
        } else {
          this.actionRequiredGroups.push({
            title: notification.title,
            notifications: [notification],
            isActionRequired: true,
          });
        }
      });

      // Then group listing issues
      const listingIssues = this.data.notifications.filter((n) => !ACTION_REQUIRED_TYPES.includes(n.notification_type));
      listingIssues.forEach((notification) => {
        const group = this.listingIssueGroups.find((g) => g.title === notification.title);
        if (group) {
          group.notifications.push(notification);
        } else {
          this.listingIssueGroups.push({
            title: notification.title,
            notifications: [notification],
            isExpanded: false,
          });
        }
      });
    }

    this.isLoading = false;
  }

  toggleGroup(group: NotificationGroup) {
    if (!group.isActionRequired) {
      group.isExpanded = !group.isExpanded;
    }
  }

  navigateToUrl(url: string) {
    window.open(url, '_blank');
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
